import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/traditional-vs-roth-calculator',
  component: () => import('../../routes/TraditionalVsRothCalculator.svelte'),
  card: {
    id: 'traditional-vs-roth-calculator',
    title: 'Traditional vs Roth Calculator',
    description: 'Compare Traditional (pre-tax) and Roth (after-tax) retirement accounts to find which saves you more based on your tax rates.',
    icon: 'account_balance',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/traditional-vs-roth-calculator',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Traditional vs Roth Calculator – Pre-Tax vs After-Tax Comparison',
    description: 'Free Traditional vs Roth calculator. Compare 401(k) pre-tax vs Roth after-tax contributions to determine which saves you more based on your current and future tax rates.',
  },
};

export default meta;